import React from 'react'

export function ARTableRow(props) {
    return <tr><td>{props.children}</td><td><input aria-label="augmented reality exercise" type="text" style={{ width: '100%' }} /></td></tr>
}
